import * as S from "./styles";
import { useGlobals } from "@/hooks";

const ContentItem = () => {
  const { cardMode, setCardMode } = useGlobals();
  const isSmallScreen = window.innerWidth < 330;

  return (
    <S.DirectionControl>
      <S.ButtonDirection
        $active={cardMode === "list"}
        data-test="filter-bar-list-button"
        onClick={() => setCardMode("list")}
      >
        <S.ListIcon size={18} />
      </S.ButtonDirection>

      <S.ButtonDirection
        disabled={isSmallScreen}
        $active={cardMode === "grid"}
        data-test="filter-bar-grid-button"
        onClick={() => setCardMode("grid")}
      >
        <S.GridIcon size={18} />
      </S.ButtonDirection>
    </S.DirectionControl>
  );
};

export default ContentItem;
